// extracted by mini-css-extract-plugin
export default {"wrapper":"TextBlock_wrapper__4DNQ-","heading":"TextBlock_heading__4z9yJ"};